module.exports = __webpack_public_path__ + "static/img/banner_3.39cef5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_3.jpg
// module id = PW5Y
// module chunks = 1 2 3 4 5 6 7 8 9